export const stakeholderOptions = [
  { label: "Frontdesk", value: "frontdesk" },
  { label: "Cluster", value: "cluster" },
  { label: "Operation", value: "operation" },
  { label: "Founder", value: "founder" },
  { label: "Security", value: "security" },
];

export const formatTime = (timeString) => {
  const timeParts = timeString.split(":"); // Split the time into [HH, mm, ss]
  const hours = parseInt(timeParts[0], 10); // Extract hours
  const minutes = parseInt(timeParts[1], 10); // Extract minutes
  const seconds = parseInt(timeParts[2], 10); // Extract seconds

  // Build formatted string with conditional display
  return `${hours ? hours + " hours " : ""}${
    minutes ? minutes + " mins " : ""
  }${seconds ? seconds + " secs" : ""}`.trim();
};
